var _path, _path2, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmcCpmPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 8c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6zm-2-0.398c0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602-4.198 0-8 3.403-8 7.602z",
    fill: "#2c2c2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 2c-3.314 0-6 2.686-6 6 0 3.314 2.686 6 6 6 3.314 0 6-2.686 6-6 0-3.314-2.686-6-6-6z",
    fill: "{color}",
    strokeWidth: 0.23409
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1.0297 .97114)",
    x: 11.842512,
    y: 10.039745,
    fill: "#000000",
    fontFamily: "'circles and sticks'",
    fontSize: "5.3952px",
    letterSpacing: "0px",
    strokeWidth: 1.0116,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 11.842512,
    y: 10.039745,
    fontSize: "5.3952px",
    strokeWidth: 1.0116,
    "text-align": "center",
    textAnchor: "middle"
  }, "\n\t\t\t\t\t{cpm}\n\t\t"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmcCpmPin);
export default __webpack_public_path__ + "static/media/GmcCpmPin.a38cfd91da9bc08fc3ef41a94764162d.svg";
export { ForwardRef as ReactComponent };